import { render, staticRenderFns } from "./PhotoBookCoverPreviewCard.vue?vue&type=template&id=05fa1dfd&scoped=true"
import script from "./PhotoBookCoverPreviewCard.vue?vue&type=script&lang=js"
export * from "./PhotoBookCoverPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookCoverPreviewCard.vue?vue&type=style&index=0&id=05fa1dfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa1dfd",
  null
  
)

export default component.exports